<div id="layout-wrapper">
    <header id="page-topbar">
        <div class="navbar-header">
            <div class="d-flex">
                <!-- LOGO -->
                <div class="navbar-brand-box">
                    <a href="#" class="logo logo-dark" routerLink="admin-dashboard">
                        <span class="logo-sm">
                            <img src="/assets/img/greenlogo.png" alt="" height="22">
                        </span>
                        <span class="logo-lg">
                            <img src="/assets/img/greenlogo.png" alt="" height="30">
                        </span>
                    </a>
                    <a href="#" class="logo logo-light" routerLink="admin-dashboard">
                        <span class="logo-sm">
                            <img src="/assets/img/greenlogo.png" alt="" height="22">
                        </span>
                        <span class="logo-lg">
                            <img src="/assets/img/greenlogo.png" alt="" height="40">
                        </span>
                    </a>
                </div>

                <button type="button"
                    class="btn btn-sm px-3 font-size-16 d-lg-none header-item waves-effect waves-light"
                    data-bs-toggle="collapse" data-bs-target="#topnav-menu-content">
                    <i class="fa fa-fw fa-bars"></i>
                </button>
            </div>

            <div class="d-flex">

                <div class="dropdown d-inline-block d-lg-none ms-2">
                    <button type="button" class="btn header-item noti-icon waves-effect"
                        id="page-header-search-dropdown" data-bs-toggle="dropdown" aria-haspopup="true"
                        aria-expanded="false">
                        <i class="mdi mdi-magnify"></i>
                    </button>
                    <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                        aria-labelledby="page-header-search-dropdown">

                        <form class="p-3">
                            <div class="form-group m-0">
                                <div class="input-group">
                                    <input type="text" class="form-control" placeholder="Search ..."
                                        aria-label="Search input">

                                    <button class="btn btn-primary" type="submit"><i
                                            class="mdi mdi-magnify"></i></button>

                                </div>
                            </div>
                        </form>
                    </div>
                </div>

                <!-- Full Screen -->
                <div class="dropdown d-none d-lg-inline-block ms-1">
                    <button type="button" class="btn header-item noti-icon waves-effect" data-bs-toggle="fullscreen"
                        (click)="fullScreen()">
                        <i class="bx bx-fullscreen"></i>
                    </button>
                </div>

                <!--Notification -->
                <div class="dropdown d-inline-block">
                    <button type="button" class="btn header-item noti-icon waves-effect"
                        id="page-header-notifications-dropdown" data-bs-toggle="dropdown" aria-haspopup="true"
                        aria-expanded="false">
                        <i class="bx bx-bell bx-tada"></i>
                        <span class="badge bg-danger rounded-pill">5</span>
                    </button>
                    <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                        aria-labelledby="page-header-notifications-dropdown">
                        <div class="p-3">
                            <div class="row align-items-center">
                                <div class="col">
                                    <h6 class="m-0" key="t-notifications">Notifications <span class="badge bg-primary ms-2">5 New</span></h6>
                                </div>
                                <div class="col-auto">
                                    <a href="#!" class="small" key="t-view-all">View All</a>
                                </div>
                            </div>
                        </div>
                        <div data-simplebar style="max-height: 300px;">
                            
                            <!-- Booking Notification -->
                            <a href="javascript: void(0);" class="text-reset notification-item">
                                <div class="d-flex">
                                    <div class="avatar-xs me-3">
                                        <span class="avatar-title bg-primary rounded-circle font-size-16">
                                            <i class="bx bx-calendar-check"></i>
                                        </span>
                                    </div>
                                    <div class="flex-grow-1">
                                        <h6 class="mb-1">New Booking Confirmed</h6>
                                        <div class="font-size-12 text-muted">
                                            <p class="mb-1"><strong>Mr. Rajesh Kumar</strong> booked <strong>Maldives Family Package</strong> for 5 persons</p>
                                            <p class="mb-0"><i class="mdi mdi-clock-outline"></i> 5 min ago</p>
                                        </div>
                                    </div>
                                </div>
                            </a>

                            <!-- Payment Notification -->
                            <a href="javascript: void(0);" class="text-reset notification-item">
                                <div class="d-flex">
                                    <div class="avatar-xs me-3">
                                        <span class="avatar-title bg-success rounded-circle font-size-16">
                                            <i class="bx bx-credit-card"></i>
                                        </span>
                                    </div>
                                    <div class="flex-grow-1">
                                        <h6 class="mb-1">Payment Received</h6>
                                        <div class="font-size-12 text-muted">
                                            <p class="mb-1"><strong>₹45,000</strong> received for booking <strong>#BK-2026-0045</strong></p>
                                            <p class="mb-0"><i class="mdi mdi-clock-outline"></i> 15 min ago</p>
                                        </div>
                                    </div>
                                </div>
                            </a>

                            <!-- Customer Inquiry -->
                            <a href="javascript: void(0);" class="text-reset notification-item">
                                <div class="d-flex">
                                    <div class="avatar-xs me-3">
                                        <span class="avatar-title bg-warning rounded-circle font-size-16">
                                            <i class="bx bx-user-check"></i>
                                        </span>
                                    </div>
                                    <div class="flex-grow-1">
                                        <h6 class="mb-1">New Customer Inquiry</h6>
                                        <div class="font-size-12 text-muted">
                                            <p class="mb-1"><strong>Priya Sharma</strong> inquired about <strong>European Tour Packages</strong></p>
                                            <p class="mb-0"><i class="mdi mdi-clock-outline"></i> 45 min ago</p>
                                        </div>
                                    </div>
                                </div>
                            </a>

                            <!-- Urgent: Payment Due -->
                            <a href="javascript: void(0);" class="text-reset notification-item">
                                <div class="d-flex">
                                    <div class="avatar-xs me-3">
                                        <span class="avatar-title bg-danger rounded-circle font-size-16">
                                            <i class="bx bx-error-circle"></i>
                                        </span>
                                    </div>
                                    <div class="flex-grow-1">
                                        <h6 class="mb-1">⚠️ Payment Due Alert</h6>
                                        <div class="font-size-12 text-muted">
                                            <p class="mb-1"><strong>₹34,000</strong> due for booking <strong>#BK-2026-0038</strong> - 2 days overdue</p>
                                            <p class="mb-0"><i class="mdi mdi-clock-outline"></i> 1 hour ago</p>
                                        </div>
                                    </div>
                                </div>
                            </a>

                            <!-- Tour Reminder -->
                            <a href="javascript: void(0);" class="text-reset notification-item">
                                <div class="d-flex">
                                    <div class="avatar-xs me-3">
                                        <span class="avatar-title bg-info rounded-circle font-size-16">
                                            <i class="bx bx-plane-takeoff"></i>
                                        </span>
                                    </div>
                                    <div class="flex-grow-1">
                                        <h6 class="mb-1">Upcoming Tour Departure</h6>
                                        <div class="font-size-12 text-muted">
                                            <p class="mb-1"><strong>Thailand Adventure Tour</strong> departs in <strong>3 days</strong></p>
                                            <p class="mb-0"><i class="mdi mdi-clock-outline"></i> 2 hours ago</p>
                                        </div>
                                    </div>
                                </div>
                            </a>

                            <!-- Visa Processing -->
                            <a href="javascript: void(0);" class="text-reset notification-item">
                                <div class="d-flex">
                                    <div class="avatar-xs me-3">
                                        <span class="avatar-title bg-secondary rounded-circle font-size-16">
                                            <i class="bx bx-passport"></i>
                                        </span>
                                    </div>
                                    <div class="flex-grow-1">
                                        <h6 class="mb-1">Visa Application Update</h6>
                                        <div class="font-size-12 text-muted">
                                            <p class="mb-1">Visa approved for <strong>Mr. Amit Singh</strong> - Dubai Tour</p>
                                            <p class="mb-0"><i class="mdi mdi-clock-outline"></i> 3 hours ago</p>
                                        </div>
                                    </div>
                                </div>
                            </a>

                            <!-- Hotel Booking -->
                            <a href="javascript: void(0);" class="text-reset notification-item">
                                <div class="d-flex">
                                    <div class="avatar-xs me-3">
                                        <span class="avatar-title bg-primary rounded-circle font-size-16">
                                            <i class="bx bx-hotel"></i>
                                        </span>
                                    </div>
                                    <div class="flex-grow-1">
                                        <h6 class="mb-1">Hotel Confirmation</h6>
                                        <div class="font-size-12 text-muted">
                                            <p class="mb-1"><strong>5-Star Resort</strong> confirmed for <strong>Honeymoon Package</strong></p>
                                            <p class="mb-0"><i class="mdi mdi-clock-outline"></i> 5 hours ago</p>
                                        </div>
                                    </div>
                                </div>
                            </a>

                            <!-- Promotional Offer -->
                            <a href="javascript: void(0);" class="text-reset notification-item">
                                <div class="d-flex">
                                    <div class="avatar-xs me-3">
                                        <span class="avatar-title bg-success rounded-circle font-size-16">
                                            <i class="bx bx-gift"></i>
                                        </span>
                                    </div>
                                    <div class="flex-grow-1">
                                        <h6 class="mb-1">🎉 Promotional Campaign Active</h6>
                                        <div class="font-size-12 text-muted">
                                            <p class="mb-1"><strong>Summer Special:</strong> 20% off on all European packages</p>
                                            <p class="mb-0"><i class="mdi mdi-clock-outline"></i> 1 day ago</p>
                                        </div>
                                    </div>
                                </div>
                            </a>

                            <!-- New Tour Package -->
                            <a href="javascript: void(0);" class="text-reset notification-item">
                                <div class="d-flex">
                                    <div class="avatar-xs me-3">
                                        <span class="avatar-title bg-info rounded-circle font-size-16">
                                            <i class="bx bx-map-pin"></i>
                                        </span>
                                    </div>
                                    <div class="flex-grow-1">
                                        <h6 class="mb-1">New Tour Package Added</h6>
                                        <div class="font-size-12 text-muted">
                                            <p class="mb-1"><strong>Kerala Backwaters Special</strong> now available for booking</p>
                                            <p class="mb-0"><i class="mdi mdi-clock-outline"></i> 1 day ago</p>
                                        </div>
                                    </div>
                                </div>
                            </a>

                            <!-- Refund Processed -->
                            <a href="javascript: void(0);" class="text-reset notification-item">
                                <div class="d-flex">
                                    <div class="avatar-xs me-3">
                                        <span class="avatar-title bg-warning rounded-circle font-size-16">
                                            <i class="bx bx-refresh"></i>
                                        </span>
                                    </div>
                                    <div class="flex-grow-1">
                                        <h6 class="mb-1">Refund Processed</h6>
                                        <div class="font-size-12 text-muted">
                                            <p class="mb-1"><strong>₹12,000</strong> refunded for cancelled booking <strong>#BK-2026-0035</strong></p>
                                            <p class="mb-0"><i class="mdi mdi-clock-outline"></i> 2 days ago</p>
                                        </div>
                                    </div>
                                </div>
                            </a>

                            <!-- Staff Alert -->
                            <a href="javascript: void(0);" class="text-reset notification-item">
                                <div class="d-flex">
                                    <div class="avatar-xs me-3">
                                        <span class="avatar-title bg-danger rounded-circle font-size-16">
                                            <i class="bx bx-user-x"></i>
                                        </span>
                                    </div>
                                    <div class="flex-grow-1">
                                        <h6 class="mb-1">Staff Attendance Alert</h6>
                                        <div class="font-size-12 text-muted">
                                            <p class="mb-1"><strong>3 staff members</strong> marked absent today</p>
                                            <p class="mb-0"><i class="mdi mdi-clock-outline"></i> 2 days ago</p>
                                        </div>
                                    </div>
                                </div>
                            </a>

                            <!-- Monthly Report -->
                            <a href="javascript: void(0);" class="text-reset notification-item">
                                <div class="d-flex">
                                    <div class="avatar-xs me-3">
                                        <span class="avatar-title bg-secondary rounded-circle font-size-16">
                                            <i class="bx bx-stats"></i>
                                        </span>
                                    </div>
                                    <div class="flex-grow-1">
                                        <h6 class="mb-1">Monthly Report Ready</h6>
                                        <div class="font-size-12 text-muted">
                                            <p class="mb-1"><strong>156 bookings</strong> this month - Revenue: ₹45,00,000</p>
                                            <p class="mb-0"><i class="mdi mdi-clock-outline"></i>This Project is created by Md Mozakkir khan</p>
                                        </div>
                                    </div>
                                </div>
                            </a>

                        </div>
                        <div class="p-2 border-top d-grid">
                            <a class="btn btn-sm btn-link font-size-14 text-center" href="javascript:void(0)">
                                <i class="mdi mdi-arrow-right-circle me-1"></i><span key="t-view-more">View All Notifications</span>
                            </a>
                        </div>
                    </div>
                </div>
                <!--Notification -->

                <!-- profile Dropdown -->
                <div class="dropdown d-inline-block">
                    <button type="button" class="btn header-item waves-effect" id="page-header-user-dropdown"
                        data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <img [src]="imageUrl + Company.LogoPNG" alt="Profile"
                            class="rounded-circle header-profile-user">
                        <span class="d-none d-xl-inline-block ms-1" key="t-henry">{{staffLogin.StaffName}}</span>
                        <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
                    </button>
                    <div class="dropdown-menu dropdown-menu-end">
                        <!-- item-->
                        <a class="dropdown-item"><i class="bx bx-user font-size-16 align-middle me-1"></i>
                            <span key="t-profile">{{staffLogin.StaffName}}</span></a>
                        <a class="dropdown-item"><i class="bx bx-wallet font-size-16 align-middle me-1"></i><span
                                key="t-my-wallet">My Wallet</span></a>
                        <a class="dropdown-item d-block"><span class="badge bg-success float-end">11</span><i
                                class="bx bx-wrench font-size-16 align-middle me-1"></i> <span
                                key="t-settings">Settings</span></a>
                        <a class="dropdown-item"><i class="bx bx-lock-open font-size-16 align-middle me-1"></i><span
                                key="t-lock-screen">Lock screen</span></a>
                        <a class="dropdown-item" routerLink="/admin/change-password">
                            <i class="bx bx-key font-size-16 align-middle me-1"></i>
                            <span>Change Password</span>
                        </a>
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item text-danger" (click)="logOut()" href=""><i
                                class="bx bx-power-off font-size-16 align-middle me-1 text-danger"></i><span
                                key="t-logout">Logout</span></a>
                    </div>
                </div>
                <!-- profile Dropdown -->

                <div class="dropdown d-inline-block">
                    <button type="button" class="btn header-item noti-icon right-bar-toggle waves-effect">
                        <i class="bx bx-cog bx-spin"></i>
                    </button>
                </div>

            </div>
        </div>
    </header>

    <!--Main Menu -->
    <div class="topnav">
        <div class="container-fluid">
            <nav class="navbar navbar-light navbar-expand-lg topnav-menu">

                <div class="collapse navbar-collapse" id="topnav-menu-content">
                    <ul class="navbar-nav">

                        <li class="nav-item dropdown">
                            <a class="nav-link" routerLink="admin-dashboard">
                                <i class="bx bx-home-circle me-2"></i><span key="t-dashboards">Dashboards</span>
                            </a>
                        </li>

                        <li class="nav-item dropdown" *ngFor="let menuOne of MenuList">

                            <!-- Level 1 -->
                            <a class="nav-link dropdown-toggle arrow-none" href="javascript:void(0)"
                                (click)="toggleMenu(menuOne.MenuId)">

                                <i [class]="menuOne.MenuIcon + ' me-2'"></i>
                                <span>{{ menuOne.MenuTitle }}</span>
                                <div class="arrow-down"></div>
                            </a>

                            <!-- Level 2 -->
                            <div class="dropdown-menu" [class.show]="activeMenu === menuOne.MenuId">

                                <a class="dropdown-item" *ngFor="let menuTwo of menuOne.MenuList"
                                    [routerLink]="menuTwo.PageUrl" (click)="closeMenu()">

                                    {{ menuTwo.MenuTitle }}
                                </a>

                            </div>

                        </li>

                    </ul>
                </div>
            </nav>
        </div>
    </div>
    <!--Main Menu -->
    
    <div class="main-content">
        <router-outlet></router-outlet>
        <footer class="footer">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-sm-6">
                        <script>document.write(new Date().getFullYear())</script>
                        © Green Island Tours & Travels Private Limited.
                    </div>
                    <div class="col-sm-6">
                        <div class="text-sm-end d-none d-sm-block">
                            Design & Develop by Webaikon Infotech
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</div>